import { useEffect, useRef } from 'react'

import { useSize } from 'ahooks'

import { EDITOR_CONTENT_WIDTH_CSS_VAR } from './constants'

export const useTraceEditorContentSize = () => {
  const editorContentRef = useRef<HTMLDivElement>(null)
  const size = useSize(editorContentRef)
  useEffect(() => {
    if (size) {
      editorContentRef.current?.style.setProperty(
        EDITOR_CONTENT_WIDTH_CSS_VAR,
        `${size.width}px`
      )
    }
  }, [size])

  return editorContentRef
}
